import React, { useState } from 'react';
import LargeUserPill from '../../../common/components/LargeUserPill';
import DataTable from '../../../common/components/DataTable';
import LegacyUserResource from '../../../common/resource/LegacyUserResource';

function TeamVisibility() {
  const updateUser = async (user, params) => {
    await LegacyUserResource.update(user.id, params);
  };

  return (
    <DataTable
      url="/resource/users/visibility"
      columns={['Person', 'Retention Status', 'Visibility', 'Flight Risk']}
      renderRow={(user) => (
        <tr>
          <td>
            <LargeUserPill user={user} />
          </td>
          <td>
            <RetentionStatus user={user} updateUser={updateUser} />
          </td>
          <td>
            <VisibilityStatus user={user} updateUser={updateUser} />
          </td>
          <td>
            <FlightRisk user={user} updateUser={updateUser} />
          </td>
        </tr>
      )}
    />
  );
}

function RetentionStatus({ user, updateUser }) {
  const [status, setStatus] = useState(user.retention_status);

  const classes = {
    s: 'text-success',
    w: 'text-info',
    c: 'text-warning',
    n: 'text-danger',
  };

  const onChange = (event) => {
    setStatus(event.target.value);
    updateUser(user, { retention_status: event.target.value });
  };

  return (
    <select
      className={`form-control ${classes[status]}`}
      defaultValue={status}
      onChange={onChange}
    >
      <option value="">Not Defined</option>
      <option value="s">Should</option>
      <option value="w">Would</option>
      <option value="c">Could</option>
      <option value="n">No</option>
    </select>
  );
}

function VisibilityStatus({ user, updateUser }) {
  const [status, setStatus] = useState(user.visibility_status);

  const classes = {
    g: 'text-success',
    m: 'text-warning',
    p: 'text-danger',
  };

  const onChange = (event) => {
    setStatus(event.target.value);
    updateUser(user, { visibility_status: event.target.value });
  };

  return (
    <select
      className={`form-control ${classes[status]}`}
      defaultValue={status}
      onChange={onChange}
    >
      <option value="">Not Defined</option>
      <option value="g">Good</option>
      <option value="m">Moderate</option>
      <option value="p">Poor</option>
    </select>
  );
}

function FlightRisk({ user, updateUser }) {
  const [status, setStatus] = useState(user.flag_flight);

  const classes = {
    0: 'text-success',
    1: 'text-danger',
  };

  const onChange = (event) => {
    setStatus(event.target.value);
    updateUser(user, { flag_flight: event.target.value });
  };

  return (
    <select
      className={`form-control ${classes[status]}`}
      defaultValue={status}
      onChange={onChange}
    >
      <option value={1}>Yes</option>
      <option value={0}>No</option>
    </select>
  );
}

export default TeamVisibility;
